export default "__VITE_ASSET__C67Zx9QT__"